import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import i18n from "../../../../i18n";
import DotCell from "ui/grid/DotCell";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { IconButtonActionType } from "interface";

let t = i18n.t;

export const gridColumnItemsHandler = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cells: {
				data: (props) => <DotCell value={props.dataItem.status} />,
			},
		},
		{ field: "registrationId", title: t("NumberShort"), width: "90px" },
		{
			field: "registrationDate",
			title: t("Date"),
			width: "110px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "registrationDate",
			title: t("Time"),
			width: "120px",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationDate}
						formatType={"HH:mm"}
					/>
				),
			},
		},
		{
			field: "numberOfLines",
			title: t("Lines"),
			width: "80px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={""} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "vesselName",
			title: t("Vessel"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "vesselRegistrationNumber",
			title: t("VesselRegistrationId"),
			width: 130,
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			width: "180px",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "buyerName",
			title: t("Buyer"),
			width: "auto",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "liveWeightKg",
			title: t("TotalWeight"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,

				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
	];
	return gridItems;
};

export const lastColumItems = ({ edit }: { edit?: (data: any) => void }) => {
	const items: any[] = [
		{
			onclick: edit,
			title: t("Edit"),
			conditionField: "status",
			iconName: ICON_NAMES.Edit,
			showConditionValue: 0,
			actionType: IconButtonActionType.Update,
		},
		{
			conditionField: "status",
			iconName: ICON_NAMES.GreenCheckbox,
			showConditionValue: 1,
		},
		{
			conditionField: "status",
			iconName: ICON_NAMES.Checkbox,
			showConditionValue: 0,
		},
	];

	return items;
};

export const registrationDetailGridItems: GridColumnProps[] = [
	{
		//this will not be render
		field: "lineNumber",
		title: "Linje",
	},
	{
		field: "lineNumber",
		title: t("Line"),
		width: "80px",
		cells: {
			data: (props) => <NumericalCell {...props} formatDecimal={0} unit={""} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
	{ field: "product", title: t("Product") },
	{ field: "packaging", title: t("Packaging"), width: "auto" },
	{
		field: "numberOfPieces",
		title: t("Pieces"),
		cells: {
			data: (props) => <NumericalCell {...props} formatDecimal={0} unit={""} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
	{
		field: "registrationLiveWeightKg",
		title: t("RegisteredWeight"),
		width: "120px",
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
	{
		field: "liveWeightKg",
		title: t("Weight"),
		width: "120px",
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
	{
		width: "40px",
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
];
